import React from "react";
import {Route} from "react-router-dom";

const module = (shopApp) => {
	const Search = shopApp.dynamic(() => import("./Search"));

	const url = "/search";

	let config = {
		name: "Search",
		routes: [
			<Route key={url} path={url} component={Search}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
